<template>
<div>
  <sui-segment v-if="mode == 'view'">
	  <sui-header>
		  <v-row>
			  <v-col cols=12 md=5>
		  <h2>{{$t(current.name)}}</h2>
			</v-col>
			  <v-col cols=12 md=1></v-col>
			  <v-col cols=12 md=6 style="text-align:right">
				<div v-if="isAdmin">
					<v-btn color="orange" @click.prevent="handleEdit"><v-icon>mdi-pen</v-icon></v-btn>&nbsp;
					<v-btn color="red"  @click.prevent="handleDelete"><v-icon>mdi-trash-can</v-icon></v-btn>
				</div>
			</v-col>
		</v-row>
	  </sui-header>
	  <sui-divider></sui-divider>
		  <v-row>
			  <v-col cols=12 md=5>
				  <img style="max-height:45vh;max-width:45vw" :src="current.image">
	  <sui-divider></sui-divider>
							<br>
			<!-- <div v-for="(extra,name) in current.extras" :key="extra">
				<h3>{{name}}</h3>
				<v-btn :key="ext" class="extra" v-for="ext in extra" @click.prevent="clickExtra(name, ext)" :color="ext.style">
					{{ext.name}}
				</v-btn>
			</div> -->

			<div v-for="extra in current.extras" :key="extra">
					<div v-if="extra.extras.length > 0">
						<v-row>
							<v-col cols=1>
							<h3>{{$t(extra.name)}}</h3>
							</v-col>
							<v-col cols=6 v-if="selectedExtras[extra.name]">
								 {{ selectedExtras[extra.name] ? $t('selected') + ": " + $t(renderExtra(selectedExtras[extra.name]))  : ""}}
							</v-col>
						</v-row>
						      <v-btn-toggle
							   v-if="extra.name != 'color'"
								mandatory
								v-model="selectedExtras[extra.name]"
								color="primary"
								>
								<div :key="ext" v-for="ext in extra.extras" :title="ext.name">
									<v-btn fab :value="ext.id">
										{{ shortName(ext.name)}}
									</v-btn>&nbsp;
								</div>
							</v-btn-toggle>
						      <v-btn-toggle
							  	v-else
								mandatory
								v-model="selectedExtras[extra.name]"
								color="primary"
								>
								<div :key="ext" v-for="ext in extra.extras">
									<v-btn fab :value="ext.id" :color="ext.style" :title="ext.name">
										{{shortName(ext.name)}}
									</v-btn>&nbsp;
								</div>
							</v-btn-toggle>
					<sui-divider></sui-divider>
					</div>
				</div>

            <!-- {{
              new Intl.NumberFormat("de-DE", {
                style: "currency",
                currency: "EUR",
              }).format(newPrice)
            }}
				<v-text-field
					v-model="amount"
					type="number"
					min="1"
					max="99"
					@change="
					newPrice = current.price * amount;
					$forceUpdate();
					"
					:label="$t('amount')"
				></v-text-field> -->
			  </v-col>
			  <v-col cols=12 md=1></v-col>
			  <v-col cols=12 md=6>
				<p style="max-height:40%; overflow-y: auto">{{current.description}}</p>
				<br>
                <v-chip
                  style="margin-right: 12px"
                  v-for="cat in current.categories"
                  :key="cat.id"
				  @click.prevent="handleClickCat(cat)"
                  :color="cat.color"
                  >{{ cat.name }}</v-chip
                >
				<br>
		<sui-divider></sui-divider><br>
					<v-btn color="green" :loading="buyLoading" block @click.prevent="addToCart" x-large><v-icon>mdi-cart</v-icon> {{$t('addToCart')}}</v-btn>
					<template v-slot:loader>
						<span class="custom-loader">
						<v-icon light>mdi-cached</v-icon>
						</span>
					</template>
				</v-col>
		  </v-row>
	    <v-overlay :value="loading"
		absolute="true">
      <v-progress-circular
        indeterminate
        size="64"
      ></v-progress-circular>
    </v-overlay>


  </sui-segment>


	<!-- Edit -->

  <sui-segment v-else>
	  <sui-header>
		  <v-row>
			<v-col cols=12 md=1>
					<v-btn color="green"  @click.prevent="handleView"><v-icon>mdi-eye</v-icon></v-btn></v-col>
			  <v-col cols=12 md=5>
		  <v-text-field large :label="$t('name')" v-model="edit.name"></v-text-field>
			</v-col>
			  <v-col cols=12 md=1></v-col>
			  <v-col cols=12 md=5 style="text-align:right">
					<v-btn color="red"  @click.prevent="handleDelete"><v-icon>mdi-trash-can</v-icon></v-btn>
			</v-col>
		</v-row>
	  </sui-header>
	  <sui-divider></sui-divider>
		  <v-row>
			  <v-col cols=12 md=5>
				               <v-file-input
								id="input"
								v-model="file"
								:label="$t('inputImage')"
								truncate-length="15"
								@change="handleLoadImage"
							></v-file-input>
				  <img style="max-height:45vh;max-width:45vw" :src="edit.image">
	  <sui-divider></sui-divider>
				<br>


				<div v-for="extra in edit.extras" :key="extra">
					<v-row>
						<v-col cols=12 md=11>
							<h3>{{$t(extra.name)}}</h3>
						</v-col>
						<v-col cols=12 md=1>
							<v-btn color="green" @click.prevent="handleAddExtras(extra)"><v-icon>mdi-plus</v-icon></v-btn>
						</v-col>
					</v-row>
					<div v-if="extra.extras.length == 0">
						
							{{$t("noExtras")}}
					</div>
					<div v-else>
					    <v-chip
						v-for="ext in extra.extras"
						:key="ext"
						class="ma-2"
						:color="ext.style || 'grey'"
						close
						@click:close="handleRemoveExtra(ext.id)"
						>
							{{$t(ext.name)}}
						</v-chip>
					</div>
				<sui-divider></sui-divider>
				</div>


							<!-- <br>
				<v-text-field
					v-model="edit.price"
					clearable
					type="number"
					min="1"
					append-icon="mdi-currency-eur"
					:label="$t('price')"
				></v-text-field> -->
				<br>
				<h4>{{$t("groups")}}</h4>
			<v-combobox
				v-if="!allGroups"
				v-model="edit.groups"
				:items="groups"
				:label="$t('groups')"
				multiple
				item-key="id"
				item-text="name"
				chips>
			<template v-slot:selection="data">
            <v-chip
			:color="data.item.color"
            >
              {{ data.item.name }}
            </v-chip>
          </template>
        </v-combobox>
		
			<v-checkbox :label="$t('allGroups')" v-model="allGroups"></v-checkbox>
			  </v-col>
			  <v-col cols=12 md=1></v-col>
			  <v-col cols=12 md=6>
				<v-textarea @change="checkDuck" :rules="rules.shortdescription" clearable counter rows="3" :label="$t('shortdescription')" v-model="edit.shortdescription" ></v-textarea>
				<br>
				<v-textarea @change="checkDuck" :rules="rules.description" clearable counter rows="15" :label="$t('description')" v-model="edit.description" ></v-textarea>
				<br>
			<v-combobox
         	v-model="edit.categories"
          	:items="categories"
			:label="$t('categories')"
          	multiple
		  	item-key="id"
			item-text="name"
          	chips>
          <template v-slot:selection="data">
            <v-chip
			:color="data.item.color"
            >
              {{ data.item.name }}
            </v-chip>
          </template>
        </v-combobox>
				<br>
		<sui-divider></sui-divider><br>
					<v-btn color="green" :loading="buyLoading" block @click.prevent="saveEdit" x-large>{{$t('save')}}</v-btn>
					<template v-slot:loader>
						<span class="custom-loader">
						<v-icon light>mdi-cached</v-icon>
						</span>
					</template>
				</v-col>
		  </v-row>
	    <v-overlay :value="loading"
		absolute="true">
      <v-progress-circular
        indeterminate
        size="64"
      ></v-progress-circular>
    </v-overlay>
			 <v-dialog v-model="showDialog" width="900">
            <v-card>
              <v-card-title class="text-h5 grey lighten-2">
                {{ $t("edit") + " " + $t(this.editExtras.name)}}
              </v-card-title>
              <v-card-text>
				  	<v-text-field v-if="editExtras.color" :placeholder="$t('name')" v-model="editExtras.extraName"></v-text-field>
				  	<v-color-picker v-if="editExtras.color" v-model="editExtras.color"></v-color-picker>
					<v-autocomplete
						v-else
						:label="size"
						dense
						chips
						multiple
						v-model="editExtras.sizes"
						:items="['S','M','L','XL','XXL','XXXL','46', '48', '50', '52', '54', '56']"
					></v-autocomplete>
					<v-btn color="green" :loading="userLoading" block @click.prevent="saveExtra">{{$t('save')}}</v-btn>
					<template v-slot:loader>
						<span class="custom-loader">
						<v-icon light>mdi-cached</v-icon>
						</span>
					</template>
			  </v-card-text>
			</v-card>
		</v-dialog> 
  </sui-segment>
  </div>
</template>

<script>
import ApiService from "@/services/ApiService.js";
import PermissionService from "@/services/PermissionService.js";
export default {
	data() {
		return {
			current: {
				name: "",
			},
				amount: 1,
			loading: false,
			mode: "view",
			id: 0,
			isAdmin: false,
			newPrice: 0,
			buyLoading: false,
			edit: {},
			selectedExtras: [],
			file: null,
			categories: [],
			editExtras: {
				id: 0,
				name: "",
				extraName: "",
				color: ""
			},
			groups: [],
			rules: {
				shortdescription:[v => v !=null && v.length <= 501 || this.$t('Max500Characters')],
				description:[v => v !=null &&  v.length <= 10001 || this.$t('Max10000Characters')],
				},
			showDialog: false,
			allGroups: false
		}
	},
	async created(){
		this.id = this.$route.params.id
		this.isAdmin = PermissionService.checkPermission("edit product", false)
		if(this.$route.query.edit && this.isAdmin){
			this.mode = "edit";
        window.history.replaceState({},document.title,window.location.origin + window.location.pathname)
		}
		this.renderContent();
		let res = await ApiService.getCategories()
		if(res.status == 200){
		this.categories = res.data.data}
		res = await ApiService.getGroups()
		if(res.status == 200){
		this.groups = res.data}
		res = await ApiService.getExtras(this.id)
		if(res.status == 200){
		this.extras = res.data
		}
		if(this.selectedExtras.length == 0){
			this.current.extras.forEach(el => {
				this.selectedExtras[el.name] = el.extras[0]
			});
		}


	},
	methods: {
		handleChangeExtras(extraCat, extra){
			this.selectedExtras[extraCat.name] = extra.id;
		},
		renderExtra(extra){
			if(this.extras !== undefined)
			return this.extras[extra] || extra
		},
		shortName(str){
			if(str.length < 6){
				return this.$t(str)
			}else{
				return this.$t(str.slice(0, 3) + "..")
			}
		},
		handleAddExtras(extra){
			this.editExtras.id = extra.id
			this.editExtras.name = extra.name
			extra.name == "color" ? this.editExtras.color = true : this.editExtras.color = false
			this.showDialog = true;
		},
		async handleRemoveExtra(id){
			let res = await ApiService.removeExtra(id)
			if(res == false){
				this.renderContent()
			}else{
				console.log(res)
			}
		},
		async saveExtras(){
			// let res = await ApiService.putEditExtras(this.id, {extras: this.edit.dialogExtras});
		},
		async saveExtra(){
			if(this.editExtras.color){
				let res = await ApiService.postAddExtra(this.id, {type: this.editExtras.id, name: this.editExtras.extraName, style: this.editExtras.color ? this.editExtras.color.hex || this.editExtras.color: null})
				if(res.status == 201){
					this.showDialog = false
					this.editExtras.extraName = ""
					this.editExtras.color = null
					this.renderContent()
				}
			}else{
				for(let size in this.editExtras.sizes){
					await ApiService.postAddExtra(this.id, {type: this.editExtras.id, name: this.editExtras.sizes[size]})
				}
				this.showDialog = false
				this.editExtras.extraName = ""
				this.editExtras.color = null
				this.renderContent()
			}
		},
		async renderContent(){
			this.loading = true
			let res = await ApiService.getProduct(this.id)
			if(res.status == 200){
				this.current = res.data
				// this.newPrice = this.current.price
				if(this.mode == "edit"){
					this.edit = this.current

					if(this.edit.groups[0].name == "all"){
						this.allGroups = true
						this.edit.groups = null
					}

				}
				this.loading = false
			}else{	
				this.$swal({
					icon: "error",
					title: this.$t("error"),
					text: res.data
				});
				this.$router.push("/")
			}
		},
		async handleClickCat(cat){
			this.$router.push("/?category="+cat.id)
		},
    async addToCart() {
		console.log(this.selected)
		this.buyLoading = true
      let res = await ApiService.addToCart({
        product_id: this.current.id,
        amount: this.amount,
		color: this.selectedExtras["color"],
		size: this.selectedExtras["size"],
      });
      if (res.status == 201) {
        this.$swal(this.$t("yea"), this.$t("added"), "success");
		this.$emit("updateNotis")
      } else {
        this.$swal(this.$t("error"), this.$t(res.data.message), "error");
      }
      this.buyLoading = false
    },
        async handleDelete(){
            this.$swal.fire({
                icon: "warning",
                title: this.$t("areYouSure"),
                text: this.$t("youCantRevert"),
                showCancelButton: false,
                showDenyButton: true,
                confirmButtonText: this.$t('yesDelete'),
                denyButtonText: this.$t("noKeep")
                }).then(async(result) => {
                if (result.isConfirmed) {
                    let res = await ApiService.deleteProduct(this.current.id);
                    if (res===false) {
                        this.updateTable++
                        this.$swal({
                            icon: "success",
                            title: this.$t("deleted"),
                            text: this.$t("deleteSuccess")
                        })
						this.$router.push("/management/products")
                    }
                }
            })
        },
		handleEdit(){
			this.mode = 'edit'
			this.edit = this.current
			if(this.edit.groups[0].name == "all"){
				this.allGroups = true
			}

		},
		handleView(){
			this.current.extras.forEach(el => {
				this.selectedExtras[el.name] = el.extras[0]
			});
			this.mode = 'view'
			this.current = this.edit
			this.$forceUpdate();
			// this.newPrice = this.current.price * this.amount
		},
		
        async handleLoadImage(){
            this.edit.image = "data:image/png;base64," + await this.getFile(this.file)
            this.$forceUpdate()
        },
        getFile(selectedFile){
            return new Promise(function(resolve,reject){
            var reader = new FileReader();
                reader.readAsDataURL(selectedFile);
                reader.onload = function () {
                    console.log("file gotten")

                    var result = reader.result.split(";base64,")[1]
                    resolve(result);
                };
                reader.onerror = function(error){
                    reject(error);
                }
            })
        },
        fileInput(){
                const fileInput = document.getElementById('input');
                const selectedFile = fileInput.files[0];
                console.log(selectedFile);   
                var reader = new FileReader();
                reader.readAsDataURL(selectedFile);
                reader.onload = function () {
                    console.log(reader.result);
                };
                reader.onerror = function (error) {
                    console.log('Error: ', error);
                };
        },
		checkDuck(){
			if(this.edit.description == "DUCKY1000"){
				this.edit.description = ""
				for(var i=0;i<1000;i++){
					this.edit.description == "" ? "" : this.edit.description += " "
					this.edit.description += "Duck"
				}
				this.edit.description += "🦆"
			}
			if(this.edit.shortdescription == "DUCKY100"){
				this.edit.shortdescription = ""
				for(i=0;i<100;i++){
					this.edit.shortdescription == "" ? "" : this.edit.shortdescription += " "
					this.edit.shortdescription += "Duck"
				}
				this.edit.shortdescription += "🦆"
			}
		},
		async saveEdit(){

			if(this.edit.shortdescription != null && this.edit.shortdescription.length > 501){
				this.$swal({
					icon: "error",
					title: this.$t("error"),
					text: this.$t("errorItsCalledShortDescriptionForAReason")
				})
				return
			}

			if(this.edit.description != null && this.edit.description.length > 10001){
				this.$swal({
					icon: "error",
					title: this.$t("error"),
					text: this.$t("errorMaxWords")
				})
				return
			}
			this.allGroups ? this.edit.groups = "all" : ""
			this.loading = true;
			this.buyLoading = true;
			let res = await ApiService.putProduct(this.edit.id,{
				"name": this.edit.name,
				"shortdescription": this.edit.shortdescription,
				"description": this.edit.description,
				"price": 0,
				"image": this.edit.image,
				"categories": this.edit.categories,
				"groups": this.edit.groups
			})
			if(res.status == 200){
				this.loading = false;
			this.buyLoading = false;


				this.current = res.data
				this.edit = this.current
				this.$forceUpdate();
				this.$swal({
					icon: "success",
					title: this.$t("yea"),
					text: this.$t("saved")
				})
			}else{
				this.loading = false;
			this.buyLoading = false;
				this.$swal({
					icon: "error",
					title: this.$t("error"),
					text: this.$t(res.data.message)
				})
			}
		}
	}
}
</script>

<style>
.extra {
	margin-right:2%;
}
img {
	max-width: 850px;
	max-height: 850px;
}
</style>